import React from 'react';

// Components
import SingleFormLayout from '../../_layout/SingleFormLayout/single-form.layout';
import { ParentLoginFormContainer } from '../../../User/ParentLoginForm/parent-login-form.container';
import { SignedInRedirect } from '../../../_core/SignedInRedirect/signed-in-redirect.component';
import { SessionType } from '../../../../lib/types/session.types';

export const ParentLoginPage: React.FC = () => (
  <SignedInRedirect tree={SessionType.PARENT}>
    <SingleFormLayout maxWidth="600px">
      <ParentLoginFormContainer />
    </SingleFormLayout>
  </SignedInRedirect>
);
